import { GlobalSettingsControl } from "@/components/common/GlobalSettingsControl";
import { ServiceTechEventCard } from "./ServiceTechEventCard";
import { useServiceTechApp } from "./useServiceTechApp";

export function ServiceTechAppShell() {
  const app = useServiceTechApp();

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/95 px-4 py-3 backdrop-blur dark:border-slate-800 dark:bg-slate-900/95">
        <div className="mx-auto flex max-w-lg items-center justify-between gap-3">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
              Service tech
            </p>
            <h1 className="text-lg font-bold leading-tight">Today&apos;s jobs</h1>
          </div>
          <div className="flex items-center gap-2">
            <span
              className={`h-2.5 w-2.5 rounded-full ${app.offline ? "bg-amber-500" : "bg-emerald-500"}`}
              title={app.offline ? "Offline" : "Online"}
            />
            <button
              type="button"
              onClick={() => void app.refresh()}
              disabled={app.syncing}
              className="rounded-lg border border-slate-300 px-3 py-1.5 text-xs font-semibold disabled:opacity-50 dark:border-slate-600"
            >
              {app.syncing ? "Syncing…" : "Sync now"}
            </button>
            <GlobalSettingsControl />
          </div>
        </div>
        {app.offline || app.fromCache ? (
          <p className="mx-auto mt-2 max-w-lg text-xs text-amber-700 dark:text-amber-300">
            {app.offline
              ? "Offline — showing cached jobs. Check-ins queue until you're back online."
              : "Showing cached manifest — tap Sync when online."}
          </p>
        ) : null}
        {app.toast ? (
          <p className="mx-auto mt-2 max-w-lg text-xs text-amber-800 dark:text-amber-200">{app.toast}</p>
        ) : null}
        {app.error ? (
          <p className="mx-auto mt-2 max-w-lg text-xs text-rose-700 dark:text-rose-300">{app.error}</p>
        ) : null}
      </header>

      <main className="mx-auto max-w-lg px-4 py-4 pb-10">
        {app.loading ? (
          <p className="text-sm text-slate-600 dark:text-slate-400">Loading your jobs…</p>
        ) : app.manifest && app.manifest.events.length > 0 ? (
          <ul className="space-y-3">
            {app.manifest.events.map((ev) => (
              <li key={ev.id}>
                <ServiceTechEventCard
                  event={ev}
                  stamping={app.stampingEventId === ev.id}
                  onCheckIn={(milestone) => void app.checkIn(ev.id, milestone)}
                />
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-sm text-slate-600 dark:text-slate-400">No jobs scheduled for today.</p>
        )}
      </main>
    </div>
  );
}
